import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from './../../../../../../../services/auth.service';
import { MemberService } from './../../../../../../../rest/api/member.service';
import { HelperService } from './../../../../../../../services/helper.service';

@Component({
  selector: 'app-edit-title-modal',
  templateUrl: './edit-title-modal.component.html',
  styleUrls: ['./edit-title-modal.component.scss']
})
export class EditTitleModalComponent implements OnInit, OnChanges {

  @Input() spaceData;
  @Input() selectedMedia;
  @Output() editMediaEmit = new EventEmitter();
  @Output() modalCloseEmit = new EventEmitter();
  updateMediaForm: FormGroup;
  accessToken: any;
  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;
  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.createHotspotsFormInit();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.selectedMedia && changes.selectedMedia.currentValue) {
      this.resetFormValues(changes.selectedMedia.currentValue);
    }
  }

  createHotspotsFormInit() {
    this.updateMediaForm = this.fb.group({
      media_name: ['', [Validators.required, Validators.maxLength(40)]],
    });
  }

  submit(value) {
    if (!this.updateMediaForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.updateMedia(data);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  updateMedia(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateMediaTitle({
      Authorization: this.accessToken,
      id: this.selectedMedia.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Title was successfully changed.';
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response ? response : undefined;
        this.editMediaEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    // this.resetFormValues(undefined);
  }

  resetFormValues(data) {
    this.updateMediaForm.reset({
      media_name: data.title,
    });
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while updating title.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.isSubmitting = false;
    this.isSubmitted = false;
  }

  closeModal() {
    this.modalCloseEmit.emit(undefined);
  }

}
